import User from "../layouts/User/User.jsx";
import Dashboard from "../layouts/Dashboard/Dashboard.jsx";

var indexRoutes = [
  { path: "/user", name: "User", component: User },
  { path: "/", name: "Home", component: Dashboard }
];

export default indexRoutes;
